import apiClient from './apiClient'

/**
 * Get multiUserLinks
 * @returns {IMultiUserLink[]}}
 */
export const getMultiUserLinks = async () => await apiClient.get('/api/MultiUserLinks/')
